import React, { useRef, useState, useEffect } from "react";
import styles from "../../v2Styles.module.css";
import { Input, DatePicker } from "antd";
import Select from "react-select";
import { CircularProgress } from "@mui/material";
import colourStyles from "./FilterSelectStyles";
import { baseApiInstance, scopeApiInstance } from "../../../../dataProvider/axiosHelper";
import { notification } from "antd";
import { Strings } from "../../../../dataProvider/localize";
import RegionStateFilter from "./RegionStateFilter";

const { RangePicker } = DatePicker;

export default function FiltersView({ tableLoading, filters = [], initialFilters = {}, filtersEndPoint, filterValues, setFilterValues, onFilter, filterColSize = 3, extraAction = null }) {

  const controller = useRef();
  const [loading, setLoading] = useState(false);
  const [defaultData, setDefaultData] = useState({});
  const [lastAsyncData, setLastAsyncData] = useState({});

  const getDefaultFilterData = () => {
    setLoading(true);
    controller.current = new AbortController();
    return scopeApiInstance.get(
      filtersEndPoint,
      { params: {}, signal: controller.current.signal },
    ).then(res => {
      if (res && res.data && res.data.data) {
        setDefaultData(data => ({ ...data, ...res.data.data }))
      }
      setLoading(false);
    }).catch(error => {
      if (error) {
        setLoading(false);
        notification.error({
          message: Strings.error_title,
          description: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error,
          className: "ant-error"
        });
      }
    })
  }


  const getFilterData = (filter) => {
    setLoading(true);
    controller.current = new AbortController();
    const instance = filter.apiType && filter.apiType === "base" ? baseApiInstance : scopeApiInstance;
    instance.get(
      filter.asyncEndPoint,
      { params: filter.fetchFilterParams ? filter.fetchFilterParams : {}, signal: controller.current.signal },
    ).then(res => {
      setLoading(false);
      let searchData = [];
      if (res && res.data && res.data.data) {
        if (filter.asyncDataKey && filter.asyncDataKey === "index") {
          searchData = res.data.data.map(x => filter.asyncDataValue && filter.asyncDataValue === "index" ? ({ label: x, value: x }) : ({ label: x[filter.asyncDataLabel], value: x[filter.asyncDataValue] }));
        } else {
          searchData = res.data.data[filter.asyncDataKey].map(x => filter.asyncDataValue && filter.asyncDataValue === "index" ? ({ label: x, value: x }) : ({ label: filter.asyncDataLabelFunc ? filter.asyncDataLabelFunc(x) : x[filter.asyncDataLabel], value: x[filter.asyncDataValue] }));
        }
      }
      setLastAsyncData(data => ({ ...data, [filter.param]: searchData }));
      return Promise.resolve(searchData);
    }).catch(error => {
      if (error) {
        setLoading(false);
        notification.error({
          message: Strings.error_title,
          description: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error,
          className: "ant-error"
        });
      }
    })
  }

  useEffect(() => {
    return () => {
      if (controller.current) {
        controller.current.abort()
      }
    }
  }, []);

  useEffect(() => {
    if (filtersEndPoint) {
      getDefaultFilterData();
    }
  }, [filtersEndPoint])

  const onClear = () => {
    setFilterValues({ ...initialFilters });
    onFilter({ ...initialFilters }, 1)
  }

  const onFilterValueChange = (v, param, endParam = null) => {
    if (endParam) {
      setFilterValues(values => ({ ...values, [param]: v[0], [endParam]: v[1] }))
    } else {
      setFilterValues(values => ({ ...values, [param]: v }))
    }
  }

  useEffect(() => {
    filters && filters.forEach((filter) => {
      if (filter.type === "AsyncSelect") {
        getFilterData(filter);
      }
    })
  }, [filters]);


  const getFilter = (filter) => {
    switch (filter.type) {
      case "Input": {
        return (
          <div className={`col-${filter.colSize ? filter.colSize : 2} pb-2`}>
            <Input
              placeholder={filter.name}
              className={styles.InputFieldV2}
              onChange={e => onFilterValueChange(e.target.value, filter.param)}
              value={filterValues[filter.param]}
            />
          </div>
        )
      }
      case "AsyncSelect": {
        return (
          <div className={`col-${filter.colSize ? filter.colSize : 2} pb-2`}>
            <Select
              placeholder={filter.name}
              onChange={(v) => onFilterValueChange(v, filter.param)}
              value={filterValues[filter.param] ? filterValues[filter.param] : null}
              options={lastAsyncData[filter.param] ? [...(filter.defaultOptions ? filter.defaultOptions : []), ...lastAsyncData[filter.param]] : [...(filter.defaultOptions ? filter.defaultOptions : [])]}
              hideSelectedOptions={false}
              aria-multiline={false}
              isLoading={loading}
              isClearable
              styles={colourStyles}
              isMulti={filter.allowMultiple}
            // menuPortalTarget={document.body}
            />
          </div>
        )
      }
      case "RegionState": {
        return (
          <RegionStateFilter
            filterValues={filterValues}
            defaultData={defaultData}
            onFilterValueChange={onFilterValueChange}
            loading={loading}
            filter={filter} />
        )
      }
      case "Select": {
        return (
          <div className={`col-${filter.colSize ? filter.colSize : 2} pb-2`}>
            <Select
              placeholder={filter.name}
              onChange={(v) => onFilterValueChange(v, filter.param)}
              value={filterValues[filter.param] ? filterValues[filter.param] : null}
              options={filter.defaultDataKey && defaultData[filter.defaultDataKey] ?
                defaultData[filter.defaultDataKey].map((x) =>
                  filter.defaultDataValue === "index" ?
                    { label: x, value: x } :
                    {
                      label: x[filter.defaultDataLabel],
                      value: x[filter.defaultDataValue]
                    }) : filter.options ? filter.options : []}
              hideSelectedOptions={false}
              isMulti={filter.allowMultiple}
              closeOnSelect={!filter.allowMultiple}
              closeMenuOnSelect={!filter.allowMultiple}
              isLoading={loading}
              clearable
              styles={colourStyles}
            // menuPortalTarget={document.body}
            />
          </div>
        )
      }
      case "DatePicker": {
        return (
          <div  className={`col-${filter.colSize ? filter.colSize : 2} pb-2`}>
            <RangePicker
              placeholder={filter.name}
              className="cs-range-picker"
              dropdownClassName="cs-datepicker-dropdown"
              allowClear={filter.allowClear === false ? false : true}
              format="DD-MM-YYYY"
              value={filter.end_param ? [filterValues[filter.param], filterValues[filter.end_param]] : filterValues[filter.param]}
              onChange={(v) => onFilterValueChange(v, filter.param, filter.end_param ? filter.end_param : null)}
            />
          </div>
        )
      }
      default: return
    }
  }

  return filters && filters.length ? (
    <div className="container-fluid py-2">
      <div className="row">
        {filters ? filters.map((filter, index) => (
          <React.Fragment key={index}>
            {getFilter(filter)}
          </React.Fragment>
        )) : null}
        <div className="col pb-2 d-flex align-items-center flex-wrap" style={{ gap: "6px" }}>
          <button disabled={tableLoading} className={styles.PrimaryButton}
            onClick={() => onFilter(filterValues)}
          >Filter</button>
          <button
            onClick={() => onClear()}
            className={`${styles.OutlinedButton} ${styles.DangerColor} ml-1`}>Reset</button>
          {extraAction ? (
            <div className="d-flex align-items-center" style={{ marginLeft: "auto", gap: "8px" }}>
              {extraAction.loading ? <CircularProgress size={14} /> : null}
              <button
                disabled={extraAction.disabled}
                onClick={extraAction.onClick}
                className={styles.SecondaryButton}
              >
                {extraAction.label ? extraAction.label : "Action"}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  ) : null
}